import { TCard, TCardItem } from '../../../types/cardColumnLayout.types';
import { TIconField, TImageField, TStringField } from '../../../../../types/sitecore.types';
import { LinkField, VideoSitecoreField } from '../../../../../types/types';
import { SplitModuleContainerProps } from '../../../../@shared/splitModuleContainer/types/splitModuleContainer.types';

export class CardModel {
  private readonly id: string;
  private readonly fields?: TCard;

  constructor(props: TCardItem) {
    this.id = props.id;
    this.fields = props?.fields || undefined;
  }

  get itemid(): string {
    return this.id || '';
  }

  get icon(): TIconField {
    return this.fields?.icon as TIconField;
  }

  get iconValue(): string {
    return this.fields?.icon?.fields?.iconKey?.value || '';
  }

  get title(): TStringField | undefined {
    return this.fields?.cardHeading;
  }

  get subheading(): TStringField | undefined {
    return this.fields?.cardSubheading;
  }

  get image(): TImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): TImageField | undefined {
    return this.fields?.mobileImage;
  }

  get video(): VideoSitecoreField | undefined {
    return this.fields?.video;
  }

  get useVideo(): boolean {
    return this.fields?.useVideo?.value || false;
  }

  get cta1(): LinkField | undefined {
    return this.fields?.cardCtaButton;
  }

  get cta2(): LinkField | undefined {
    return this.fields?.cardCtaTextLink;
  }

  get validcta2Exists(): boolean {
    return !!(this?.cta2?.value?.text && this?.cta2?.value?.href);
  }

  get downloadButtonLink(): LinkField | undefined {
    return this.fields?.downloadButtonLink;
  }

  get validDownloadExists(): boolean {
    return !!(this?.downloadButtonLink?.value?.text && this?.downloadButtonLink?.value?.href);
  }

  get showPopupWithSplitModule(): boolean {
    return (
      (!this.cta1 || (!this.cta1?.value?.url && !this.cta1?.value?.href)) &&
      !!this.fields?.items?.[0].fields?.items?.[0] &&
      !!this.splitModuleLabel
    );
  }

  get splitModules(): SplitModuleContainerProps[] {
    return this.fields?.items?.[0].fields?.items as SplitModuleContainerProps[];
  }

  get splitModuleLabel(): string | undefined {
    return this.fields?.items?.[0]?.fields?.popUpLabel?.value;
  }
}
